import {Flag, type FlagProps} from 'platform/components';

import i18n from '@dms/i18n';

import {getNewVehicleEnumLabel, type NewVehicleLabelGroup} from '../../utils/newVehicleLabels';
import {getNewVehicleEnumColorScheme} from './getNewVehicleEnumColorScheme';

export type NewVehicleStatusFlagProps = {
  group: NewVehicleLabelGroup;
  value: string;
  size?: FlagProps['size'];
};

export function NewVehicleStatusFlag(props: NewVehicleStatusFlagProps) {
  return (
    <Flag
      label={getNewVehicleEnumLabel(props.group, props.value, (key, defaultValue) =>
        i18n.t(key, {defaultValue})
      )}
      colorScheme={getNewVehicleEnumColorScheme(props.group, props.value)}
      size={props.size}
      isSubtle
    />
  );
}
